module.exports = __webpack_public_path__ + "static/media/classplanner.5ffbd82b.jpg";